import { ReactNode } from 'react';
import { Button, FieldError, Label, ListBox, Popover, Select as AriaSelect, SelectValue, Text } from 'react-aria-components';
import type { SelectProps as AriaSelectProps, ValidationResult } from 'react-aria-components';



interface SelectProps<T extends object> extends Omit<AriaSelectProps<T>, 'children'> {
	label?: string;
	description?: string;
	errorMessage?: string | ((validation: ValidationResult) => string);
	items?: Iterable<T>;
	children: ReactNode | ((item: T) => ReactNode);
}


export function Select<T extends object>(props: SelectProps<T>) {
	const { label, isRequired = false, description, errorMessage, children, items, ...otherProps } = props;
	return (
		<AriaSelect {...otherProps} isRequired={isRequired}>
			<Label>{label} {isRequired && <span>*</span>}</Label>
			
			<Button>
				<SelectValue />
				<span aria-hidden="true">▼</span>
			</Button>
			
			{description &&
				<Text slot="description">{description}</Text>}
			
			<FieldError>{errorMessage}</FieldError>
		
			<Popover>
				<ListBox { ...(items && { items: items })}>
					{children}
				</ListBox>
			</Popover>
		
		</AriaSelect>
	);
}